import React from 'react'
import { Link } from 'react-router-dom'

const TopBlock = () => {
  return (
    <div className='block' style={{height: "70vh"}}>
            <div className='top' style={{width: `100%`, height: "35vh"}}>
                <h1>Find your next top tech job in 1 week.</h1>
                <p style={{fontSize: "20px"}}> <span style={{backgroundColor: "yellow"}}>Are you a top 2%</span> Software Engineer, Product Manager or Data Scientist?<br></br></p>
                <p style={{fontSize: "20px"}}>Let leading Indian technology <span style={{backgroundColor: "yellow"}}>companies compete to hire you.</span> </p>
            </div>
            <div className="d-flex joinBtn mt-5">
              <Link to="/signup"><button className='joinBtninside'>Apply To Join</button></Link>
                  <p className='mt-3' style={{color: "grey", fontSize: "15px"}}>100% free. It takes only 5 minutes</p>
            </div>
    </div>
  )
}

export default TopBlock